import { Injectable } from '@angular/core';
import { CoreHttpClient } from '@core-modules/providers/core-http-client/core-http-client';
import { EnvironmentProvider } from '@core-modules/providers/environment-variables/environment';
import { PolicyDetails } from 'valuations/models/policy-details';
import { PortfolioSummary } from 'valuations/models/portfolio-summary';

/*
  Generated class for the ValuationsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ValuationsProvider
{

    //#region Constructor

    /**
     * Class constructor
     * @param http
     * @param environment
     */
    constructor
        (
            private http: CoreHttpClient,
            private environment: EnvironmentProvider
        )
    {
    }

    //#endregion


    //#region Methods

    /**
     * Get the portfolio summary for the client
     * Resolves if the client has policies,
     * rejects if no data available
     * @param sessionToken client token
     */
    public getPortfolioSummary(sessionToken: string): Promise<PortfolioSummary>
    {
        // if either the portfolio summary is not present
        // or the refresh flag is present
        // fetch the summary from the server
        let requestUrl: string = `${this.environment.apiEndpoint}/mobileapp/Valuation/GetPortfolioSummary/${sessionToken}`;
        return this.http.get<PortfolioSummary>(requestUrl);
    }

    /**
     * Get the policy details for a particular policy
     * @param policyToken policy token
     */
    public async getPolicyDetails(policyToken: string): Promise<PolicyDetails>
    {
        // fetch the policy details
        let requestUrl: string = `${this.environment.apiEndpoint}/mobileapp/Valuation/GetPolicyDetails/${policyToken}`;
        let policyDetails = await this.http.get<PolicyDetails>(requestUrl)

        // resolve the promise
        return policyDetails;
    }

    /**
     * Download a valuation
     * @param factSheet LiveFactSheet data
     */
    public async downloadValuation(policyToken: string)
    {
        let requestUrl = `${this.environment.apiEndpoint}/mobileapp/Valuation/DownloadPolicyValuation/${policyToken}`;
        await this.http.downloadFile(requestUrl)
    }

    /**
     * Download a fact sheet
     * @param factSheet LiveFactSheet data
     */
    public async downloadFactSheet(holdingName: string, holdingToken: string)
    {
        let requestUrl = `${this.environment.apiEndpoint}/mobileapp/Valuation/DownloadStructuredNoteFactSheet/${holdingToken}`;
        await this.http.downloadFile(requestUrl)
    }


    //#endregion


}
